import React from "react";
import { MarkersPlugin } from "@photo-sphere-viewer/markers-plugin";
import ReactDOMServer from "react-dom/server";
import { IoWarning } from "react-icons/io5";

const MARKERS_POSITIONS_KEY = "tour_markers_positions";

/**
 * Carrega todas as posições de marcadores salvas.
 * @returns {object} Um objeto onde a chave é o ID do relatório e o valor é a posição.
 */
const loadMarkerPositions = () => {
  const saved = localStorage.getItem(MARKERS_POSITIONS_KEY);
  return saved ? JSON.parse(saved) : {};
};

/**
 * Salva a posição de um novo marcador.
 * @param {string} reportKey - O ID/key único do relatório.
 * @param {{yaw: number, pitch: number}} position - A posição a ser salva.
 */
export const saveMarkerPosition = (reportKey, position) => {
  const positions = loadMarkerPositions();
  positions[reportKey] = position;
  localStorage.setItem(MARKERS_POSITIONS_KEY, JSON.stringify(positions));
};

/**
 * Cria um Data URI de SVG para usar como ícone.
 */
const createIconUri = (iconComponent, props) => {
  const iconString = ReactDOMServer.renderToStaticMarkup(
    React.createElement(iconComponent, props)
  );
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(iconString)}`;
};

/**
 * Atualiza os marcadores na cena com base nos relatórios e suas posições salvas.
 * @param {Viewer} viewerInstance - A instância do viewer.
 * @param {string} currentSceneName - O nome do arquivo da cena atual.
 * @param {Array} allReports - A lista completa de relatórios do Redux.
 * @param {function} onMarkerClick - Callback a ser executado quando um marcador é clicado.
 */
export const updateMarkers = (
  viewerInstance,
  currentSceneName,
  allReports,
  onMarkerClick
) => {
  if (!viewerInstance) return;

  const markersPlugin = viewerInstance.getPlugin(MarkersPlugin);
  if (!markersPlugin) return;

  markersPlugin.clearMarkers();
  const markerPositions = loadMarkerPositions();

  const sceneReports = allReports.filter(report => markerPositions[report.key]);

  sceneReports.forEach(report => {
    const position = markerPositions[report.key];

    if (position) {
      markersPlugin.addMarker({
        id: `report-${report.key}`,
        position: { yaw: position.yaw, pitch: position.pitch },
        image: createIconUri(IoWarning, {
          color: "#FFF",
          size: 25,
          style: {
            filter: `drop-shadow(0 0 2px rgba(0,0,0,0.8))`,
            stroke: "black",
            strokeWidth: "10"
          }
        }),
        size: { width: 45, height: 45 },
        anchor: "center center",
        tooltip: report.titulo,
        data: {
          reportKey: report.key
        }
      });
    }
  });

  const listener = e => onMarkerClick(e.marker.data);
  markersPlugin.removeEventListener("select-marker", listener);
  markersPlugin.addEventListener("select-marker", listener);
};
